import type { SipHealthHeroProps } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/SipTab/SipHealthHero/index.types';
import {
  TONE,
} from 'Modules/softphone/components/SoftphoneDevTools/styles';
import {
  formatTimestamp,
  getSipHealthStatus,
} from 'Modules/softphone/components/SoftphoneDevTools/utils';
import React from 'react';
import { cn } from '~/lib/utils';

const HERO = {
  healthy: { tone: TONE.ok, glyph: '✓', label: 'Registration healthy' },
  warning: { tone: TONE.warn, glyph: '…', label: 'Registration in progress' },
  error: { tone: TONE.bad, glyph: '✕', label: 'Not registered' },
} as const;

/**
 * SipHealthHero - Registration, in one sentence
 *
 * The attempt count belongs next to the verdict rather than in a table:
 */
export const SipHealthHero: React.FC<SipHealthHeroProps> = ({
  status,
  registrationAttempts,
  lastRegistrationTime,
}) => {
  const { tone, glyph, label } = HERO[getSipHealthStatus(status)];

  return (
    <div className={cn('flex items-center gap-3 p-3.5', tone.inset, 'rounded-[10px]')}>
      <span
        className={cn(
          'flex h-[34px] w-[34px] flex-shrink-0 items-center justify-center rounded-full border-2 text-[15px]',
          tone.text,
          tone.dot.replace('bg-', 'border-')
        )}
      >
        {glyph}
      </span>

      <div className="min-w-0 flex-1">
        <p className={cn('text-[13px] font-semibold', tone.text)}>{label}</p>
        <p className="text-[11.5px] text-zinc-300">
          {registrationAttempts === 0
            ? 'no failed attempts since'
            : `${registrationAttempts} failed ${registrationAttempts === 1 ? 'attempt' : 'attempts'} since`}{' '}
          {lastRegistrationTime ? 'the last success at' : 'startup'}{' '}
          {lastRegistrationTime && (
            <span className="font-sp-mono">
              {formatTimestamp(lastRegistrationTime, {
                fallback: 'never',
                withDate: true,
              })}
            </span>
          )}
        </p>
      </div>
    </div>
  );
};
